export const videos = [
  {
    id: "v001",
    title: "2024年度最火爆综艺节目大盘点",
    description: "回顾2024年最受欢迎的综艺节目，从选秀到真人秀，从脱口秀到音乐竞技，带你重温那些令人难忘的精彩瞬间。各大平台王牌节目的高光时刻全收录。",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20variety%20show%20stage%20with%20colorful%20spotlights%2C%20performers%20on%20stage%2C%20dramatic%20lighting%2C%20entertainment%20studio%20atmosphere%2C%20professional%20broadcast%20production%2C%20warm%20theatrical%20glow%2C%20clean%20minimal%20background&width=800&height=450&seq=video-ent-01&orientation=landscape",
    category: "entertainment",
    duration: "15:28",
    views: 235890,
    date: "2024-12-10",
    tags: ["综艺", "盘点", "2024", "热门"],
    content: "本期节目为您带来2024年度综艺节目的全面回顾。从年初的选秀热潮到年中的真人秀爆发，再到年末的音乐竞技巅峰对决，每一档节目都有其独特的魅力。我们精选了各大平台收视率最高的节目片段，涵盖湖南卫视、浙江卫视、东方卫视等主流电视台，以及爱奇艺、腾讯视频、优酷等网络平台的原创综艺。无论您是综艺爱好者还是行业从业者，这期盘点都不容错过。",
  },
  {
    id: "v002",
    title: "零基础学Python：从入门到实战",
    description: "专为编程新手打造的Python入门课程，手把手教你掌握Python编程核心技能，配合实际项目练习。",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20modern%20coding%20workspace%20with%20laptop%20showing%20Python%20code%20on%20screen%2C%20clean%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20minimalist%20tech%20aesthetic%2C%20educational%20technology%20scene%2C%20soft%20neutral%20background&width=800&height=450&seq=video-edu-01&orientation=landscape",
    category: "education",
    duration: "45:12",
    views: 189720,
    date: "2024-12-08",
    tags: ["Python", "编程", "入门", "教程"],
    content: "这是一套完整的Python编程入门课程，从环境搭建到基本语法，从数据类型到面向对象编程，逐步深入。课程包含大量实战练习和项目案例，让学习不再枯燥。适合零基础的编程初学者，也适合想系统复习Python基础的开发者。",
  },
  {
    id: "v003",
    title: "iPhone 16 Pro Max 深度体验评测",
    description: "苹果最新旗舰手机全面评测，从外观设计到性能表现，从影像系统到续航能力，真实体验分享。",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20new%20smartphone%20on%20a%20clean%20white%20marble%20surface%2C%20minimalist%20product%20photography%20with%20soft%20natural%20lighting%2C%20premium%20tech%20device%20showcase%2C%20editorial%20style%2C%20warm%20neutral%20background&width=800&height=450&seq=video-tech-01&orientation=landscape",
    category: "technology",
    duration: "22:35",
    views: 456120,
    date: "2024-12-05",
    tags: ["iPhone", "苹果", "评测", "数码"],
    content: "iPhone 16 Pro Max作为苹果最新旗舰，带来了诸多升级。我们对其进行了为期两周的深度体验，从日常使用、游戏性能、拍照效果、续航表现等多个维度进行全面评估。这次评测完全基于真实使用场景，不含任何商业合作，给你最真实的购买参考。",
  },
  {
    id: "v004",
    title: "家常红烧肉最正宗的做法",
    description: "五星级大厨教你做入口即化的红烧肉，肥而不腻、瘦而不柴，学会这道菜你就是家里的厨神！",
    thumbnail: "https://readdy.ai/api/search-image?query=Delicious%20Chinese%20braised%20pork%20belly%20dish%20on%20a%20ceramic%20plate%2C%20glossy%20caramelized%20surface%2C%20steaming%20hot%2C%20warm%20kitchen%20lighting%2C%20food%20photography%20style%2C%20clean%20wooden%20table%20background%2C%20home%20cooking%20aesthetic&width=800&height=450&seq=video-life-01&orientation=landscape",
    category: "lifestyle",
    duration: "12:48",
    views: 321560,
    date: "2024-12-03",
    tags: ["美食", "家常菜", "红烧肉", "烹饪"],
    content: "红烧肉是中华美食的经典代表之一。本期视频邀请拥有三十年烹饪经验的五星级酒店大厨，从选肉、切肉、焯水、炒糖色到慢炖，每一个步骤都详细讲解。掌握这些技巧，你也能做出色泽红亮、入口即化的完美红烧肉。",
  },
  {
    id: "v005",
    title: "NBA赛季十大经典绝杀回顾",
    description: "回顾NBA本赛季最激动人心的十大绝杀瞬间，每一球都让人热血沸腾！",
    thumbnail: "https://readdy.ai/api/search-image?query=Exciting%20basketball%20game%20winning%20shot%20moment%2C%20player%20shooting%20in%20dramatic%20lighting%2C%20packed%20arena%20atmosphere%2C%20sports%20photography%20style%2C%20intense%20energy%2C%20warm%20stadium%20lights%2C%20professional%20basketball%20scene&width=800&height=450&seq=video-sports-01&orientation=landscape",
    category: "sports",
    duration: "18:55",
    views: 512340,
    date: "2024-11-30",
    tags: ["NBA", "篮球", "绝杀", "集锦"],
    content: "本赛季NBA赛场上的绝杀球层出不穷，每一记绝杀都凝聚着球员的汗水和团队的信任。我们从数百场比赛中精选了十个最经典的绝杀瞬间，带你重温那些令人血脉偾张的时刻。从压哨三分到突破上篮，从个人能力到团队配合，这些绝杀将永远被铭记。",
  },
  {
    id: "v006",
    title: "华语乐坛经典金曲串烧",
    description: "华语乐坛三十年精华浓缩，从邓丽君到周杰伦，每一首都是时代的印记。",
    thumbnail: "https://readdy.ai/api/search-image?query=Warm%20music%20performance%20stage%20with%20vintage%20microphone%20and%20soft%20golden%20spotlight%2C%20nostalgic%20concert%20atmosphere%2C%20emotional%20singing%20scene%2C%20retro%20warm%20tones%2C%20music%20studio%20background%2C%20artistic%20performance%20photography&width=800&height=450&seq=video-music-01&orientation=landscape",
    category: "music",
    duration: "32:10",
    views: 198760,
    date: "2024-11-28",
    tags: ["音乐", "华语", "经典", "金曲"],
    content: "华语乐坛三十年的辉煌历程，诞生了无数脍炙人口的经典歌曲。本期视频精选了从80年代到新世纪的华语金曲，从邓丽君的甜美柔情到Beyond的摇滚精神，从张学友的情歌经典到周杰伦的创新突破，每一首都是那个年代最深刻的音乐记忆。",
  },
  {
    id: "v007",
    title: "原神4.0版本全角色强度排行",
    description: "最新版本各角色强度分析，从T0到T3全面评估，帮你合理规划抽卡和培养资源。",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20game%20character%20illustration%20with%20magical%20elements%2C%20colorful%20vibrant%20art%20style%2C%20gaming%20aesthetic%2C%20clean%20digital%20art%20background%2C%20warm%20fantasy%20tones%2C%20adventure%20game%20atmosphere&width=800&height=450&seq=video-game-01&orientation=landscape",
    category: "gaming",
    duration: "25:40",
    views: 387210,
    date: "2024-11-25",
    tags: ["原神", "游戏", "角色", "排行"],
    content: "原神4.0版本带来了全新的角色和机制调整。本期视频我们对当前版本所有五星和四星角色进行了全面的强度评估，从主C输出、辅助能力、泛用性等多个维度进行分析。无论你是新手还是老玩家，这份角色强度排行榜都能帮你做出更好的培养决策。",
  },
  {
    id: "v008",
    title: "中国航天：从东方红到空间站",
    description: "中国航天事业的发展历程，从第一颗人造卫星到天宫空间站，见证中国航天的辉煌成就。",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20space%20station%20orbiting%20above%20Earth%2C%20dramatic%20space%20scene%20with%20stars%2C%20solar%20panels%20glowing%2C%20scientific%20documentary%20aesthetic%2C%20deep%20space%20atmosphere%2C%20inspiring%20technological%20achievement%2C%20clean%20cosmic%20background&width=800&height=450&seq=video-doc-01&orientation=landscape",
    category: "documentary",
    duration: "52:18",
    views: 145630,
    date: "2024-11-20",
    tags: ["航天", "中国", "纪录片", "科技"],
    content: "从1970年东方红一号升空，到如今的天宫空间站遨游太空，中国航天事业走过了五十多年的辉煌历程。这部纪录片通过珍贵的历史影像和最新的太空画面，完整呈现了中国航天的奋斗史，展现了航天人的智慧和勇气。",
  },
  {
    id: "v009",
    title: "2024秋冬时尚穿搭趋势解析",
    description: "今年秋冬最流行的穿搭风格，从色彩搭配到单品推荐，教你穿出高级感。",
    thumbnail: "https://readdy.ai/api/search-image?query=Elegant%20autumn%20winter%20fashion%20outfit%20display%20on%20minimalist%20racks%2C%20warm%20neutral%20tones%20with%20textured%20fabrics%2C%20fashion%20studio%20photography%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20premium%20clothing%20presentation&width=800&height=450&seq=video-fashion-01&orientation=landscape",
    category: "fashion",
    duration: "16:22",
    views: 276450,
    date: "2024-11-18",
    tags: ["时尚", "穿搭", "秋冬", "美妆"],
    content: "2024秋冬时尚趋势以大自然的温暖色调为主，棕色系、米色系和深红色成为本季主打色。本期视频我们邀请了知名时尚博主和造型师，为大家详细解析今秋最流行的穿搭风格，从日常通勤到约会聚会，总有一款适合你。",
  },
  {
    id: "v010",
    title: "儿童绘本故事：小兔子的奇幻冒险",
    description: "精美绘本动画，讲述小兔子在奇幻森林中的冒险故事，适合3-6岁小朋友观看。",
    thumbnail: "https://readdy.ai/api/search-image?query=Cute%20illustrated%20children%20book%20scene%20with%20a%20rabbit%20in%20a%20magical%20forest%2C%20colorful%20whimsical%20art%20style%2C%20soft%20pastel%20colors%2C%20friendly%20animal%20characters%2C%20warm%20storybook%20aesthetic%2C%20dreamy%20background%20with%20flowers%20and%20butterflies&width=800&height=450&seq=video-kids-01&orientation=landscape",
    category: "kids",
    duration: "08:35",
    views: 98450,
    date: "2024-11-15",
    tags: ["儿童", "故事", "绘本", "动画"],
    content: "小兔子白白在一个阳光明媚的早晨，意外跌入了一个神奇的树洞，进入了一个充满奇幻色彩的森林。在这里，她遇到了会说话的蘑菇、会飞的松鼠和善良的大灰狼。这个故事通过精美的绘本动画呈现，寓教于乐，培养孩子的想象力和勇气。",
  },
  {
    id: "v011",
    title: "爆笑综艺名场面合集：笑到停不下来",
    description: "全网最搞笑的综艺名场面大合集，保证让你笑出腹肌！",
    thumbnail: "https://readdy.ai/api/search-image?query=Funny%20comedy%20TV%20show%20scene%20with%20bright%20studio%20lights%2C%20comedians%20laughing%20on%20stage%2C%20entertainment%20broadcast%20atmosphere%2C%20colorful%20stage%20design%2C%20warm%20spotlight%20glow%2C%20humorous%20variety%20show%20aesthetic&width=800&height=450&seq=video-ent-02&orientation=landscape",
    category: "entertainment",
    duration: "20:15",
    views: 678920,
    date: "2024-11-12",
    tags: ["综艺", "搞笑", "合集", "娱乐"],
    content: "本期为大家整理了近期综艺节目中最搞笑的名场面，从跑男的整蛊到极限挑战的神操作，从脱口秀的爆梗到选秀节目的翻车现场，每一个片段都能让你捧腹大笑。温馨提示：观看前请勿饮水，后果自负！",
  },
  {
    id: "v012",
    title: "高等数学速成：微积分核心概念精讲",
    description: "大学生期末复习必备！微积分重点难点一网打尽，让你轻松通过考试。",
    thumbnail: "https://readdy.ai/api/search-image?query=Mathematical%20formulas%20on%20a%20clean%20whiteboard%2C%20calculus%20equations%20written%20neatly%2C%20educational%20classroom%20setting%2C%20warm%20academic%20atmosphere%2C%20minimalist%20study%20environment%2C%20soft%20indoor%20lighting&width=800&height=450&seq=video-edu-02&orientation=landscape",
    category: "education",
    duration: "38:45",
    views: 134560,
    date: "2024-11-10",
    tags: ["数学", "微积分", "大学", "复习"],
    content: "临近期末，微积分是不是让你焦头烂额？别担心，本期视频由清华数学系博士主讲，用最通俗易懂的方式讲解微积分核心概念——极限、导数、积分。每个概念都配有典型例题解析，帮你快速掌握考试重点。",
  },
  {
    id: "v013",
    title: "华为Mate 70 Pro vs 小米15 Ultra 全面对比",
    description: "两大国产旗舰手机巅峰对决，从性能、拍照、续航到价格，全方位对比帮你做选择。",
    thumbnail: "https://readdy.ai/api/search-image?query=Two%20premium%20smartphones%20side%20by%20side%20on%20a%20dark%20minimalist%20surface%2C%20product%20comparison%20photography%2C%20soft%20dramatic%20lighting%2C%20clean%20tech%20aesthetic%2C%20modern%20device%20showcase%2C%20neutral%20dark%20background&width=800&height=450&seq=video-tech-02&orientation=landscape",
    category: "technology",
    duration: "28:15",
    views: 543210,
    date: "2024-11-08",
    tags: ["华为", "小米", "对比", "旗舰"],
    content: "华为和小米作为国产手机的两位领头羊，各自的最新旗舰都实力不俗。本期视频我们从外观设计、屏幕素质、性能跑分、拍照效果、续航充电、系统体验等多个维度进行了全方位对比测试。所有测试数据基于同等条件，给你最公正的对比参考。",
  },
  {
    id: "v014",
    title: "酸菜鱼的正宗做法：酸辣鲜香一锅端",
    description: "学会了这道酸菜鱼，家里来客人再也不怕没硬菜，简单几步做出饭店水准。",
    thumbnail: "https://readdy.ai/api/search-image?query=Spicy%20Chinese%20sour%20cabbage%20fish%20soup%20in%20a%20large%20ceramic%20bowl%2C%20steaming%20hot%20with%20chili%20peppers%2C%20appetizing%20food%20photography%2C%20warm%20dining%20table%20setting%2C%20home%20cooked%20meal%20aesthetic%2C%20clean%20wooden%20background&width=800&height=450&seq=video-life-02&orientation=landscape",
    category: "lifestyle",
    duration: "14:30",
    views: 432100,
    date: "2024-11-05",
    tags: ["美食", "酸菜鱼", "川菜", "家常"],
    content: "酸菜鱼是川菜中的经典名菜，酸辣鲜香，鱼肉嫩滑。本期视频教大家家庭版酸菜鱼的制作方法，从选鱼、片鱼、腌制到熬汤，每一步都有详细的技巧讲解。即使你是厨房小白，按照教程也能做出让全家人惊艳的美味酸菜鱼。",
  },
  {
    id: "v015",
    title: "世界杯经典比赛回顾：决赛之夜",
    description: "回顾世界杯历史上最精彩的决赛对决，每一个进球都是永恒经典。",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20soccer%20world%20cup%20final%20stadium%20celebration%20scene%2C%20players%20lifting%20trophy%2C%20confetti%20in%20the%20air%2C%20dramatic%20stadium%20lighting%2C%20sports%20victory%20moment%2C%20grand%20ceremony%20atmosphere%2C%20clean%20green%20pitch&width=800&height=450&seq=video-sports-02&orientation=landscape",
    category: "sports",
    duration: "35:20",
    views: 398740,
    date: "2024-11-02",
    tags: ["世界杯", "足球", "决赛", "经典"],
    content: "世界杯决赛是足球运动的最高舞台。本期视频带你重温历史上最经典的几场世界杯决赛——从马拉多纳的1986到齐达内的1998，从伊涅斯塔的绝杀到梅西的加冕。每一场决赛都是一个时代的故事，每一个进球都是一段永恒的记忆。",
  },
  {
    id: "v016",
    title: "吉他入门教学：十分钟学会弹唱",
    description: "零基础吉他教学，从持琴姿势到基础和弦，十分钟让你弹出第一首歌。",
    thumbnail: "https://readdy.ai/api/search-image?query=Acoustic%20guitar%20on%20a%20wooden%20stand%20with%20warm%20sunlight%20streaming%20through%20window%2C%20cozy%20music%20room%20atmosphere%2C%20soft%20natural%20lighting%2C%20musical%20instrument%20photography%2C%20clean%20minimalist%20background%2C%20creative%20artistic%20vibe&width=800&height=450&seq=video-music-02&orientation=landscape",
    category: "music",
    duration: "10:22",
    views: 167890,
    date: "2024-10-30",
    tags: ["吉他", "入门", "弹唱", "音乐"],
    content: "想学吉他但不知道从哪里开始？这期视频专为零基础新手设计，从选琴建议、调音方法到持琴姿势，再到C、Am、F、G四个基础和弦的按法，十分钟让你弹出人生中第一首弹唱歌曲。学吉他其实没有想象中那么难！",
  },
];

export const featuredVideos = videos.slice(0, 8);

export const getVideosByCategory = (categorySlug: string) => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getVideoById = (id: string) => {
  return videos.find((v) => v.id === id) || null;
};